;(function($, undefined){
    'use strict';

    var rnn = window.rnn,
        logoutUrl,
        accountEditUrl,
        confirmUrl,
        createCommentLoginForm,
        currentAbsoluteUrl = window.location.pathname + window.location.search,
        featureArticle = $('.feature_body').length;

    /////////////////////
    // Ajax Defaults
    /////////////////////

    var ajaxDefaults ={
        beforeSend: function(){
            this.clickedLink && loading.start(this.clickedLink);
            this.target && this.target.find('.alert-error').remove();
        },
        error: function(jqXHR, textStatus, errorThrown){
            this.clickedLink && loading.stop(this.clickedLink);
            this.loadingInfo && this.loadingInfo.remove();
            if (this.target){
                this.target.append($.el.div(
                    $.el.p(
                        'Unfortunately, there was a problem loading the comments.'
                    )
                ));
            }
            window.console && window.console.log && console.log([jqXHR, textStatus, errorThrown]); // Log this even on production!
        }
    };

    /////////////////////
    // Loading Helpers
    /////////////////////

    var loading ={
        start: function($clickedLink){
            $clickedLink
            .bind('click', eventHandlers.disabled)
            .data('oldText', $clickedLink.text())
            .text('Loading Comments...')
            .addClass('loading')
            .css('cursor', 'wait');
        },
        stop: function($clickedLink){
            $clickedLink
            .unbind('click', eventHandlers.disabled)
            .text($clickedLink.data('oldText'))
            .css('cursor', 'pointer');
        },
        info: function(message, type){
            return $($.el.div({'class': 'loadingBar ' + type || ''},
                $.el.p(message)
            ));
        }
    };

    /////////////////////
    // Render Cancel Button
    /////////////////////

    function renderCancelButton(){
        return $.el.a({'class': 'icon-remove cancel'});
    }

    /////////////////////
    // Render Reply Button
    /////////////////////

    function renderReplyButton(){
        var isFrozen = $('.comments-frozen').length;

        if(!isFrozen){
            return $.el.a({'class': 'reply', href: 'javascript:void(0)'}, 'Reply');
        }else{
            // nothing
        }
    }

    /////////////////////
    // Render Image
    /////////////////////

    function addThumbnailSpec(imageUrl, specString) {
        var url = document.createElement("a");
        url.href = imageUrl;
        var pathname = url.pathname;
        var dotIndex = pathname.lastIndexOf(".");
        if (dotIndex == -1) {
            url.pathname = pathname + specString;
        } else {
            url.pathname = pathname.substring(0, dotIndex) + specString + pathname.substring(dotIndex);
        }
        return url.href;
    }

    function renderImage(imageUrl){
        return $.el.img({src: addThumbnailSpec(imageUrl,'_ct40x40'),'class': 'avatar', height: '40px', width: '40px'});
    }

    /////////////////////
    // Format User
    /////////////////////

    function formatUser(commentData){
        var userProfileUrl = commentData.user.absoluteUrl,
            user = '',
            date = new Date(commentData.timestamp * 1000),
            locality = commentData.locality && $.el.strong(commentData.locality),
            replyCount = commentData.replies && (commentData.replies.length + (commentData.more || 0));

        if (userProfileUrl) {
            user = commentData.user && $.el.a({href: userProfileUrl}, commentData.user.displayName || commentData.user.name) || $.el.strong('Anonymous');
        } else {
            user = commentData.user && $.el.a({}, commentData.user.displayName || commentData.user.name) || $.el.strong('Anonymous');
        }

        return [user,'  ·  ',locality,' '];
    }

    /////////////////////
    // Render User
    /////////////////////

    function renderUser(commentData){
        return $.el.span.apply(this, formatUser(commentData));
    }

    /////////////////////
    // Render Reply Body
    /////////////////////

    function renderBody(body){
        var bodyText = $.el.p();
        bodyText.innerHTML = body.replace(/\n/g, '<br/>');
        return bodyText;
    }

    function renderRemoved(){
        return $.el.p(
            $.el.em(
                'This comment was removed.'
            )
        );
    }

    /////////////////////
    // Render Comment
    /////////////////////

    function renderComment(commentData,level){
        var overlayMarkerData = '{"edit_url": "/admin/comments/findacomments/' + commentData.id + '/", "content_type": "findacomments", "label": "' + (commentData.user ? commentData.user.name + ': ' : '') + (commentData.body ? commentData.body.substr(0, 50) : 'Removed comment') + '..."}',
            date = new Date(commentData.timestamp * 1000),
            ContentClass = 'content';
        if(level >=2){
            ContentClass += ' level_3';
        }else if (level ==1){
            ContentClass += ' level_2';
        }else{
            ContentClass += ' level_1';
        }

        return $.el.div({'class': 'comment', 'data-comment-id': commentData.id, 'data-overlay-marker': overlayMarkerData},

            $.el.div({'class': ContentClass},
                $.el.div({'class': 'details'},
                    commentData.user,
                    commentData.user.image && renderImage(commentData.user.image),
                    renderUser(commentData),
                    $.el.span({'class': 'timeago', title: moment(date).format("Do MMM YYYY hh:m a")}, $.timeago(date))

                ),
                $.el.div({'class': 'details_quoted'},
                    renderQuote(commentData)
                ),

                commentData.removed && renderRemoved() || renderBody(commentData.body),

                $.el.div({'class': 'reply-wrap'},
                    $.el.p({'class': ' reply-report-wrap'},
                        !commentData.removed && renderReplyButton(commentData)
                    ),
                    $.el.a({'class': 'report margin-left', href: rnn.site.commentFlagURL + commentData.id + '/'}, 'Report')
                )
            )
        );
    }

    /////////////////////
    // NEW Render quote: only the user
    /////////////////////

    var renderQuote = function(data){
        var res = '';
        if(data.quote){
            res = $.el.span({'class': 'arrow'}, '\u27F6',
                $.el.span({'class': 'quoted_user'}, data.quote.user.displayName)
            );
        }
        return res;
    };

    /////////////////////
    // Render Thread
    /////////////////////

    function renderThread(commentData){
        return $.el.li({'class': 'thread', 'data-comment-id': commentData.id},
            renderComment(commentData,0)
        );
    }

    /////////////////////
    // Show Frozen
    /////////////////////

    function showCommentsClosed($target){
        $target.find('.frozenMessage').remove();
        $target.prepend($.el.p({'class': 'frozenMessage'}, 'Comments have been closed for this story'));
        $('.add-comment').hide();
    }

    /////////////////////
    // Render Comments
    /////////////////////

    function renderComments(target, commentData, level){
        var commentsModule = target.closest('.comments'),
            meta = commentsModule.data('comment-meta') || {},
            repliesElement,
            replies = commentData.replies || commentData.threads,
            renderReplyFunction,
            plural;

        //If this reply has replies.
        if (replies){
            if(target.is('.comments')){
                repliesElement = target.children('.threads');
                renderReplyFunction = renderThread;
            }else{
                repliesElement = target.children('.replies');
                if(!repliesElement.length){
                    repliesElement = $($.el.ul({'class': 'replies'}));
                    target.append(repliesElement);
                }
                renderReplyFunction = renderComment;
            }

            for(var i = 0; i < replies.length; i++){
                var reply = $(renderReplyFunction(replies[i], level));
                renderComments(reply, replies[i], level+1);

                if(!commentsModule.find('[data-comment-id="' + replies[i].id + '"]').length){

                    if(target.is('.thread, .comments')){
                        //if its a reply to a .thread or .comments, add it to the list of replies..
                        repliesElement.append(reply);
                    }else{
                        //..otherwise, append it after the reply it is replying to.
                        target.after(reply);
                    }
                }
            }

            var buildShowMoreButton = function(showMoreText) {
                target.append(
                    $.el.a({href: '#more-replies', 'class': 'show-more', 'onclick' : showMore},
                        $.el.div({'class': 'button-default button-icon-bubble'},
                            showMoreText,
                            $.el.i({'class': 'tangram-icon icon-right icon-arrow-down-thick'})
                        )
                    )
                );
            };

            if(featureArticle && !repliesElement.is(':visible') || !featureArticle && commentData.more) {
                if(target.is('.comments')){
                    var viewAll = "View All Comments";
                    buildShowMoreButton(viewAll);
                } else {
                    if(commentData.more) {
                        plural = commentData.more == 1 ? 'Reply' : 'Replies';
                        var viewMore = "View " + commentData.more + " More " + plural;
                        buildShowMoreButton(viewMore);
                    }
                }
            }
        }

        if(meta.total){
            plural = meta.total == 1 ? '' : 's';
            commentsModule.find('.counts').text(meta.total + ' comment' + plural);
            $('.countComments').text(meta.total + ' comment' + plural);
            $('.heading-counts').show();
        }
        rnn.messaging.publish("contentPositionChanged");
    }


    /////////////////////
    // Show Login Form
    /////////////////////

    function showLoginForm(target, message, isError){
        var loginForm;

        target = target.closest('[data-comment-id], .comments');
        loginForm = createCommentLoginForm('Join the Discussion', message, isError).hide();

        var register = $.el.p({'class': 'new-register'});
        $(register).append($.el.a({'class': 'pull-right forgot-link', 'href': rnn.site.resetPasswordURL}, 'Forgot password?'));

        var signUp = $.el.p({'class': 'register'},
            "Don't have an account? ",
            $.el.a({'class': 'btn btn-primary signup', 'href': rnn.site.registerURL}, 'Sign Up')
            );

        var divFormFacebook = $.el.div({'class': 'only-facebook-api'});
        var link = $.el.a({'class': 'fb-login-button', 'href': 'javascript:void(0);'}, 'Login with ');
        $(link).append($.el.span({}, 'Facebook'));

        var hiddenFacebook = $.el.input({'type': 'hidden', 'name': 'next', 'value': currentAbsoluteUrl + '#comments', 'id': 'id_next'});

        $(divFormFacebook).append(link);

        $(loginForm).append(hiddenFacebook, divFormFacebook, register, signUp);

        if(target.is('.comment, .comments')){
            target.prepend(loginForm);
            loginForm.addCLass("AddMe");
        }else{
            target.children('.comment').append(loginForm);
            loginForm.addCLass("AddTwo");
        }

        return loginForm;
    }


    /////////////////////
    // Create Reply Form
    /////////////////////

    function createPostForm(target, message, isError, user){
        var profileUrl = '',
            imgAvatar = {},
            level_class = 'level_1';
        rnn.modules.user.get(function(user){

            if(!user.authenticated){
                profileUrl = '';
            }else{
                profileUrl = unescape(user.encoded_avatar_url).replace(/^(.*)?(\..*?)$/, '$1_ct60x60$2') ;
                imgAvatar = jQuery.extend(imgAvatar, {src: profileUrl});
            }
        });

        if($(target).find('div.content').length >0){
             level_class = $(target).find('div.content').attr('class').split(' ')[1];
        }

        var commentsModule = target.closest('.comments'),
            meta = commentsModule.data('comment-meta'),
            userTools,
            subscribeAttributes,

            form = $($.el.form({id: 'reply', 'class': 'addComments ' + level_class, method: 'post', action: 'reply'},
            $.el.a({'class': 'icon-remove cancel'}),
            $.el.h5(''),
            userTools = $.el.div({'class': 'userTools only-facebook-api'}),
            $.el.div({'class': 'messages'}),
            $.el.div({'class': 'discussion'},
                $.el.div({'class': 'avatar'},
                    $.el.img(jQuery.extend(imgAvatar, {'id': 'displayImage', height: '60px', width: '60px'}))
                ),
                $.el.div({'class': 'speech'},
                    $.el.textarea({name: 'body', 'class': 'replyBox', maxlength: meta.maxLength})
                    )
            )
        ));

        rnn.modules.user.get(function(user){
            var confirmLink,
                loginForm;
                loginForm = createCommentLoginForm(null,null,null,meta);

            $(document).on('login', function(event){
                console.log("User has logged in event executed");
            });

            if(!user.authenticated){
                form.append(
                  loginForm
                );
                form.append(
                    $.el.div({'class': 'discussionBottom'},
                        $.el.div({'class': 'discussion_label'},
                            $.el.label({'class': 'emailWhenPublished loginNotify', 'style':!meta.preModerated &&'display:none;'},
                                $.el.input({class: 'loginNotify',name: 'email_when_published', type: 'checkbox', checked: 'checked'}),
                                'Notify me by email when my comment is published.'
                            ),
                            $.el.label({'class': 'loginNotify notifyMeOfUpdates'},
                                subscribeAttributes ={name: 'subscribe_to_conversation', type: 'checkbox'},
                                (meta.subscribed && (subscribeAttributes['checked'] = 'checked', null)),
                                $.el.input(subscribeAttributes),
                                $.el.span('Notify me of updates to this conversation.')
                            )
                        ),
                        $.el.div({'class': 'discussion_btn'},
                            $.el.input({type: 'hidden', name: 'reply_id', value: target.data('comment-id')}),

                            $.el.button({type: 'submit', 'class': 'button-default-dark submitComment'}, 'Post')
                        )
                    )
                );

                $(userTools).append(
                    $.el.input({'type': 'hidden', 'name': 'next', 'value': currentAbsoluteUrl + '#comments', 'id': 'id_next'}),
                    $.el.a({'class': 'fb-login-button-new', 'href': 'javascript:void(0);'}, $.el.p({'class': 'fbimg'}),'Sign in with Facebook '),
                    $.el.a({'class': 'signup', 'href': rnn.site.registerURL}, 'Create Account')
                );

            }else{
                form.append(
                    $.el.div({'class': 'discussionBottom'},
                        $.el.div({'class': 'discussion_label'},
                            $.el.label({'class': 'emailWhenPublished loginNotify1', 'style':!meta.preModerated &&'display:none;'},
                                $.el.input({class: 'loginNotify',name: 'email_when_published', type: 'checkbox', checked: 'checked'}),
                                $.el.span('Notify me by email when my comment is published.')
                            ),
                            $.el.label({'class': 'loginNotify1 notifyMeOfUpdates'},
                                subscribeAttributes ={name: 'subscribe_to_conversation', type: 'checkbox'},
                                (meta.subscribed && (subscribeAttributes['checked'] = 'checked', null)),
                                $.el.input(subscribeAttributes),
                                $.el.span('Notify me of updates to this conversation.')
                            )
                        ),
                        $.el.div({'class': 'discussion_btn'},
                            $.el.input({type: 'hidden', name: 'reply_id', value: target.data('comment-id')}),
                            $.el.button({type: 'submit', 'class': 'button-default-dark submitComment'}, 'Post')
                        )
                    )
                );
              $(userTools).append(
                  $.el.span('Signed in as',
                      $.el.a({'id': 'displayName', 'class': 'displayClass', 'href':'/profile/' + user.username}, user.display_name)
                  )
              );
            }
            $('.discussionCheck').prependTo('.submitLogin');
            $(confirmLink).on('click', function(){
                $.ajax({
                    url: confirmUrl,
                    success:function(){
                        $(confirmLink).replaceWith(
                            $.el.span('A confirmation email has been sent')
                        );
                    },
                    error:function(){
                        $(confirmLink).replaceWith(
                            $.el.span('Unfortunatly, an error occured, please reload the page')
                        );
                    }
                });
            });
        });

        return form;
    }

    /////////////////////
    // Show Reply Form
    /////////////////////

    function showPostForm(target, message, isError, user){
        var postForm;
        target = target.closest('[data-comment-id], .comments');
        postForm = createPostForm(target, message, isError, user);

        if(target.is('.comments')){
            target.prepend(postForm);
            postForm.addClass('baseForm').hide();
            autosize(postForm.find('textarea'));
            if(!target.closest('.comments').data('comment-meta').frozen){
                $('#comments').prepend(
                    $.el.div({'class': 'comment-title-button margin-bottom'},
                        $.el.h5({'class': 'add-comment-title'},'Join the discussion'),
                        $.el.a({href: '#more-replies', 'class': 'add-comment button-default-dark button-icon-bubble', 'onclick' : unhideLogin},
                            'Add Comment',
                            $.el.i({'class': 'tangram-icon icon-right icon-arrow-down-thick'})
                        )
                    )
                );
            }

        }else{
            target.append(postForm);
            postForm.addClass('reply-field');
            postForm.find("h5").remove();
            postForm.find(".icon-remove").remove();
            postForm.find(".login").attr("id","replyLoginForm");
        }

        if ($('#displayImage').prop('src').length > 0) {
            $('.avatar').addClass('hasProfileImg');
        }

        postForm.bind('submit', eventHandlers.formSubmit);

        return postForm;
    }

    /////////////////////
    // Unhide Login Form
    /////////////////////

    function unhideLogin(){
        $('.addComments').slideDown(1000);
        $('.add-comment, .reply-field').slideUp(500);
        $('.threads').find('.reply-inactive').removeClass('reply-inactive').addClass('reply').text('REPLY');
    }

    /////////////////////
    // Show All Comments
    /////////////////////

    function showMore(){
        $(this).slideUp(500);
        var target = $(this).closest('.thread, .comments');
        loadComments(target);

        if (featureArticle) {
            $('.threads').slideDown(1000);
        }
    }

    /////////////////////
    // Show Login and Post Form
    /////////////////////

    function showLoginAndPostForm(target, message, isError){
        var postForm;

        target = target.closest('[data-comment-id], .comments');
        postForm = createPostForm(target, message, isError);

        if(target.is('.comments')){
            target.prepend(postForm);
            autosize(postForm.find('textarea'));
        }

        postForm.bind('submit', eventHandlers.formSubmit);

        return postForm;
    }

    /////////////////////
    // Show Appropriate Form
    /////////////////////

    function showForm(target, message, error){
        var form,
            meta = target.closest('.comments').data('comment-meta') || {};

        rnn.modules.user.get(function(user){

            var $oldForm = target.closest('.threads').find('form');

            $oldForm.slideUp(400, function(){
                $(this).remove();
            });

            if(!user.authenticated){
                form = showPostForm(target, null, null, user);
                message && rnn.modules.alert.show(form.find('.messages'),{'message':message || 'Please log in to post a comment', 'type':error && 'error'});
                $('.discussionBottom').hide();
                rnn.modules['facebook'].init();
            }else{
                form = showPostForm(target);
                message && rnn.modules.alert.show(form.find('.messages'),{'message':message, 'type':error && 'error'});
            }
            if(meta.disabled || meta.frozen){
                form.hide();
            }
        });
    }

    /////////////////////
    // Update Comment Meta
    /////////////////////

    function updateCommentMeta(commentsModule, data){
        commentsModule.data('comment-meta', data.meta || {});

        //If the comments have been changed to post moderated
        if(data.meta.preModerated){
            commentsModule.find('.emailWhenPublished').show();
        }else{
            commentsModule.find('.emailWhenPublished').hide();
            commentsModule.find('.emailWhenPublished checkbox').prop('checked',false);
        }
        if(data.meta.frozen){
            showCommentsClosed(commentsModule.removeClass('disabled').addClass('comments-frozen'));
        }else if(data.meta.disabled){
            showCommentsClosed(commentsModule.removeClass('comments-frozen').addClass('disabled'));
        }else{
            commentsModule.removeClass('disabled comments-frozen');
        }
    }

    /////////////////////
    // Load Comments
    /////////////////////

    function loadComments(target){
        var commentsUrl = target.closest('[data-comments-url]').data('comments-url'),
            options = $.extend({}, ajaxDefaults),
            loadingBar = loading.info('Loading...'),
            targetForm = target.children('form'),
            closestCommentsList = target.closest('.comments, .threads'),
            referenceID = target.children('.threads, .replies').children().last().data('comment-id'),
            threadID = target.data('comment-id'),
            threadLimit;

        if(targetForm.length){
            targetForm.before(loadingBar);
        }else{
            target.append(loadingBar);
        }

        options.url = commentsUrl;

        // a fix for IE8, JS is great!
        if (referenceID === null) {
            referenceID = undefined;
        }

        if (featureArticle) {
            threadLimit = undefined;
        } else {
            threadLimit = 2;
        }

        options.data = {
            reference_id: referenceID,
            thread_id: threadID,
            thread_limit: threadLimit
        };

        // if user is not logged in
        rnn.modules.user.get(function(user){
            if(!user || !user.authenticated){
                options.success = function(commentData){
                    $('.threads .thread .comment:last').removeClass('lastComment');
                    $('.threads .thread').removeClass('lastComment');
                    updateCommentMeta(target.closest('.comments'), commentData);
                    renderComments(target, commentData,0);
                    if(closestCommentsList.is('.comments') && !targetForm.length){
                        showForm(closestCommentsList);
                    }
                    loadingBar.remove();

                    $('.threads .thread .comment:last').addClass('lastComment');
                    $('.threads .thread:last').addClass('lastComment');
                };
                $.ajax(options);
          } else{
              options.success = function(commentData){
                  $('.threads .thread .comment:last').removeClass('lastComment');
                  $('.threads .thread').removeClass('lastComment');
                  updateCommentMeta(target.closest('.comments'), commentData);
                  renderComments(target, commentData,0);
                  if(closestCommentsList.is('.comments') && !targetForm.length){
                      showForm(closestCommentsList);
                  }
                  loadingBar.remove();
                  $('.threads .thread .comment:last').addClass('lastComment');
                  $('.threads .thread:last').addClass('lastComment');
              };
              $.ajax(options);
          }
        });
    }

    function submitComment(target){
        var form = $(target);

        target = form.closest('.thread, .comments');

        var targetTextbox = form.find('.replyBox'),
          loadingBar;

        rnn.modules.user.get(function(user){

        if(user.authenticated){
            /*
            TODO: We'll need to refactor the UGC's errors and this into a
            module and use them here - we were not actually reporting back
            what the error was, and it could be multiple errors. This is the
            best version but it lacks UGC's click event to focus errored fields.
            Port that too. Here we could also handle the special case of not
            being logged in, and show the login form instead of post form again.
            */
            var errorFunction = function(data){

                // on error find the closest comment instead of closest thread
                target = form.closest('.comment, .comments');


                var targetNEW = target.closest('[data-comment-id], .comments');

                /////START OF BLOAT FOR REFACTOR
                var errorFields = data.errors,
                    errorMessages = $($.el.ul());

                if(!errorFields){ return; }

                for(var key in errorFields){
                    var errorField = errorFields[key],
                        fieldErrors = "";
                    if (typeof errorField === 'string'){
                        errorMessages.append($($.el.li({'data-errorfor': key}, errorField)));
                    } else if (errorField instanceof Array){
                        for(var i = 0; i < errorField.length; i++){
                            fieldErrors += " " + errorField[i];
                            errorMessages.append($($.el.li({'data-errorfor': key}, errorField[i])));
                        }
                    }
                }
                /////END BLOAT FOR REFACTOR

                rnn.modules.alert.show(form.find('.messages'),{
                    'message':errorMessages,
                    'type': 'error'
                });
                loadingBar.remove();
            };

            loadingBar = loading.info('Posting Comment');

            if($(targetTextbox).length && $(targetTextbox).val().length <= 0){
                $('.alert-error').remove();
                var errorMessages = $($.el.ul());
                errorMessages.append($($.el.li('Textfield is required.')));
                rnn.modules.alert.show(form.find('.messages'),{
                  'message':errorMessages,
                  'type': 'error'
                });
                return 0;

            } else{

                $.ajax({
                    url: form.closest('[data-comments-url]').data('comments-url'),
                    type: 'post',
                    data: form.serialize(),
                    contentType: 'application/json',
                    success: function(data){
                        var alert;

                        if($('.replyBox').length && $('.replyBox').val().length != 0){
                          updateCommentMeta(target.closest('.comments'), data);
                        }

                        if(data.result === 'error'){
                            errorFunction(data);
                            loadingBar.remove();
                        } else if(data.result === 'success'){
                            if(target.is('.comments')){
                                form.remove();
                                $('.add-comment-title').remove();
                                showForm(target);
                            }
                            if(data.isPublic){
                                loadingBar.after(alert).remove();
                                loadComments(target);
                            } else{
                                alert = rnn.modules.alert.show(null,{
                                    type: 'success',
                                    message: 'Your comment was successfully submitted and will appear once approved'
                                });
                                loadingBar.after(alert).remove();
                            }
                        }
                    },
                    error: function(){
                        errorFunction();
                        loadingBar.remove();
                    }
                });
            }
            form.after(loadingBar).hide();
            $('.reply-field').hide();
            $('.reply-inactive').removeClass().addClass('reply').text('REPLY');
        }
    });
  };

    /////////////////////
    // Event Handlers
    /////////////////////

    var eventHandlers ={
        disabled: function(){return false;},

        changeText: function(){
            var target = $('.reply-inactive');

            target.Click(function(){
              $(this).text('REPLY');
            });
        },

        reply: function(event){
            var isFrozen = $('.comments-frozen').length;

            if(!isFrozen){
                var target = $(this),
                $threads = target.closest('.threads');

                event.preventDefault();

                $threads.find('form.addComments:not(.loading), form.login:not(.loading)').prev('.content').find('.reply-inactive').removeClass('reply-inactive').addClass('reply').text('REPLY');

                $threads.find('form.addComments:not(.loading), form.login:not(.loading)').slideUp(200, function(){
                    $(this).remove();
                });

                target.removeClass('reply').addClass('reply-inactive').text('CANCEL');


                showForm(target);
            }
        },
        cancelReply: function(event){
            var $clickedLink = $(this),
                $replyInActive = $clickedLink.parent('form').prev('.content').find('.reply-inactive'),
                $comment = $clickedLink.closest('[data-comment-id]');

            event.preventDefault();

            $('.reply-field').slideUp(500);
            $clickedLink.removeClass('reply-inactive').addClass('reply').text('REPLY');
            $replyInActive.removeClass('reply-inactive').addClass('reply').text('REPLY');
        },
        moveToCommentForm: function(event){
            var $formTopPosition = $('#comments > form').last();
             $('html, body').animate({
                scrollTop: $formTopPosition.offset().top - 60
            }, 400);
        },
        moveToCommentFormBubble: function(scroll){
            var $formTopPosition = $('#comments');

            var scrollOffset = 92;
            if ($('.desktopNav').hasClass('stuck'))
                scrollOffset = 50;

            if (scroll) {
                $('html, body').animate({
                    scrollTop: $formTopPosition.offset().top - scrollOffset
                }, 1800);
            }
            else {
                $('html,body').scrollTop($formTopPosition.offset().top - scrollOffset);
            }
        },
        checkCommentFromTop: function(previousTop, checkCount){
            var newTop = $('#comments').offset().top;
            var commentsTimeout;

            if (previousTop != newTop) {
                checkCount = 0;
                eventHandlers.moveToCommentFormBubble(false);
                commentsTimeout = setTimeout(function() {
                    eventHandlers.checkCommentFromTop(newTop, checkCount)
                }, 1000);
            }
            else if (checkCount < 3) {
                checkCount++;
                commentsTimeout = setTimeout(function() {
                    eventHandlers.checkCommentFromTop(newTop, checkCount)
                }, 1000);
            }
        },
        formSubmit: function(event){
            event.preventDefault();
            submitComment(event.target);
        }
    };

    ////////////////////
    // Init
    /////////////////////

    function initComments(){
        logoutUrl = rnn.site.logoutURL,
        accountEditUrl = rnn.site.accountEditURL,
        confirmUrl = rnn.site.accountConfirmURL,
        createCommentLoginForm = rnn.modules.login.createCommentForm;

        var commentsModules = $('.comments[data-comments-url]');

        commentsModules.each(function(){
            var commentsModule = $(this);

            commentsModule.append(
                $.el.div({'class': 'heading-counts'},
                    $.el.h4({'class': 'counts'}),
                    $.el.hr({'class': 'hrBar'})
                ),
                $.el.ul({'class': 'threads'})
            );
            loadComments(commentsModule);
        });
        
        $('.heading-counts').hide();

        if (featureArticle) {
            $('.threads').hide();
        }

        commentsModules.on('click', '.reply', eventHandlers.reply);
        commentsModules.on('click', '.reply-inactive', eventHandlers.cancelReply);
        commentsModules.on('click', '.icon-remove.cancel', eventHandlers.cancelReply);
        commentsModules.on('click', '.join-discuss', eventHandlers.moveToCommentForm);

        $('.comments-frozen').on('click', '.reply', eventHandlers.disabled);

        $(rnn).on('login',function(evt){
            var $comments = $('#comments');

            if (!$comments.length)
                return;

            rnn.modules.comments.submitComment($(evt.target).parent());

            $comments.find('form.login').each(function(){
                var $this = $(this);
                $this.parent().find('.loadingBar').remove();
                $this.remove();

            });
            $('.discussionBottom').show();
            rnn.modules.user.get(function(user){
                var usr = user;
                $('#displayName').text(usr.display_name);
                $('#displayName').attr('href', ('/profile/' + usr.username));
                $('#displayImage').attr('src',(decodeURIComponent(usr.encoded_avatar_url)));
            });

        }).on('loginError',function(event){
             $(event.target).closest('[data-comment-id], .comments').find('.loadingBar.login').remove();
        });

        $( ".comment-link" ).on('click', function(e) {
            e.preventDefault();
            eventHandlers.moveToCommentFormBubble(true);
        });

        if (window.location.hash == '#comments' && $('#comments').length) {
            $(document).ready(function() {
                eventHandlers.moveToCommentFormBubble(false);
                var newTop = $('#comments').offset().top;
                var commentsTimeout = setTimeout(function() {
                    eventHandlers.checkCommentFromTop(newTop, 0)
                }, 1000);
            });
        }
    }

    rnn.modules.register('comments',{
        init: initComments,
        submitComment: submitComment
    });

})(jQuery);
